/*!
 * devextreme-angular
 * Version: 22.1.11
 * Build date: Mon Aug 28 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */

import { NestedOption } from 'devextreme-angular/core';
import {
    Component,
} from '@angular/core';


@Component({
    template: ''
})
export abstract class DxoVectorMapProjectionConfig extends NestedOption {
    get aspectRatio(): number {
        return this._getOption('aspectRatio');
    }
    set aspectRatio(value: number) {
        this._setOption('aspectRatio', value);
    }

    get from(): Function {
        return this._getOption('from');
    }
    set from(value: Function) {
        this._setOption('from', value);
    }

    get to(): Function {
        return this._getOption('to');
    }
    set to(value: Function) {
        this._setOption('to', value);
    }
}
